import { render, staticRenderFns } from "./ModalStructure.vue?vue&type=template&id=5ea643bc&"
import script from "./ModalStructure.vue?vue&type=script&lang=js&"
export * from "./ModalStructure.vue?vue&type=script&lang=js&"
import style0 from "./ModalStructure.vue?vue&type=style&index=0&id=5ea643bc&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports